import { BrowserRouter, Routes, Route,useNavigate  } from "react-router-dom";
import { ToastContainer,toast  } from 'react-toastify';
import { useEffect } from "react";
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import axios from 'axios';
import { API_URL } from './config/api';
import Layout from './Components/Layout';
import ProtectedRoute from './Components/ProtectedRoute';
import PublicRoute from './Components/PublicRoute';
import AdminLogin from './Screens/AdminLogin';
import Login from './Screens/Login';
import Dashboard from './Screens/Dashboard';
import Forget from './Screens/Forget';
import Reset from './Screens/Reset';
import EmployeeAdd from './Screens/EmployeeAdd';
import Employee from './Screens/Employee';
import EmployeeView from './Screens/EmployeeView';
import EmployeeEdit from './Screens/EmployeeEdit';
import EmployeeInvite from "./Screens/EmployeeInvite";
import EmployeeSelf from "./Screens/EmployeeSelf";
import Holiday from "./Screens/Holiday";
import HolidayView from "./Screens/HolidayView";
import Waiting from "./Screens/Waiting";
import LeaveManagement from "./Screens/LeaveManagement";
import LeaveApply from "./Screens/LeaveApply";
import LeaveHistory from "./Screens/LeaveHistory";
import LeaveBalance from "./Screens/LeaveBalance";
import WorkLocation from "./Screens/WorkLocation";
import WorkLocationMap from "./Screens/WorkLocationMap";
import TimesheetReport from "./Screens/TimesheetReport";
import Report from "./Screens/Report";
import Department from "./Screens/Department";
import Designation from "./Screens/Designation";
import ReportingManager from "./Screens/ReportingManager";
import Profile from "./Screens/Profile";
import SalaryAllocation from "./Screens/SalaryAllocation";
import SalaryAllocationAdd from "./Screens/SalaryAllocationAdd";
import SalaryAllocationEdit from "./Screens/SalaryAllocationEdit";
import SalaryAllocationView from "./Screens/SalaryAllocationView";
import Payslip from "./Screens/Payslip";
import PayslipView from "./Screens/PayslipView";
import PayslipApproval from "./Screens/PayslipApproval";
import PayslipEdit from "./Screens/PayslipEdit";
import PassowordRest from "./Screens/PassowordRest";
import AttendanceUpdate from "./Screens/AttendanceUpdate";
import SalaryStructure from "./Screens/SalaryStructure";
import StoreAssets from "./Screens/StoreAssets";
import StoreAssetsAdd from "./Screens/StoreAssetsAdd";
import StoreAssetsEdit from "./Screens/StoreAssetsEdit";
import StoreAssetsView from "./Screens/StoreAssetsView";
import ApplyResignation from "./Screens/ApplyResignation";
import ApplicationStatus from "./Screens/ApplicationStatus";
import ApplicationStatusView from "./Screens/ApplicationStatusView";
import AssetsHandover from "./Screens/AssetsHandover";
import TermsAndConditions from './Screens/TermsAndConditions'; // adjust path


function SessionWatcher() {
  const navigate = useNavigate();

useEffect(() => {
  const checkSession = async () => {
    const id = localStorage.getItem('id');
    const role = localStorage.getItem('role');

    if (!id || !role) return;

    try {

      const action = role === 'employee'
        ? 'validate-employee-session'
        : 'validate-employee-session';

      const response = await axios.post(API_URL, {
        action,
        currentUserId: id,
      });

      const data = typeof response.data === 'string'
        ? JSON.parse(response.data)
        : response.data;

      if (data.forceLogout) {
        localStorage.clear();
        toast.error(data.message || 'Your account has been deactivated.');
        navigate(role === 'employee' ? '/' : '/admin');
      }

    } catch (error) {
      const errData = error.response?.data;

      const parsed = typeof errData === 'string'
        ? JSON.parse(errData)
        : errData;

      if (parsed?.forceLogout) {
        localStorage.clear();
        toast.error(parsed.message || 'Your account has been deactivated.');
        navigate(role === 'employee' ? '/' : '/admin');
      }
    }
  };

  checkSession();

}, [navigate]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
     <SessionWatcher />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/admin" element={<PublicRoute><AdminLogin /></PublicRoute>} />
        <Route path="/forget" element={<PublicRoute><Forget /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><PassowordRest /></PublicRoute>} />
        <Route path="/accept-employee-invite" element={<PublicRoute><Reset /></PublicRoute>} />
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/add-employee" element={<EmployeeAdd />} />
          <Route path="/employee" element={<Employee />} />
          <Route path="/employeeview/:id" element={<EmployeeView />} />
          <Route path="/employeeedit/:id" element={<EmployeeEdit />} />
          <Route path="/employeeInvite" element={<EmployeeInvite />} />
          <Route path="/userdetails" element={<EmployeeSelf />} />
          <Route path="/holiday" element={<Holiday />} />
          <Route path="/holiday-view" element={<HolidayView />} />
          <Route path="/waiting" element={<Waiting />} />
          <Route path="/leave-management" element={<LeaveManagement />} />
          <Route path="/leave-apply" element={<LeaveApply />} />
          <Route path="/leave-history" element={<LeaveHistory />} />
          <Route path="/leave-balance" element={<LeaveBalance />} />
          <Route path="/work-location" element={<WorkLocation />} />
          <Route path="/work-location-map/:id" element={<WorkLocationMap />} />
          <Route path="/timesheet-report" element={<TimesheetReport />} />
          <Route path="/report" element={<Report />} />
          <Route path="/department" element={<Department />} />
          <Route path="/designation" element={<Designation />} />
          <Route path="/reporting-manager" element={<ReportingManager />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/payroll-allocation" element={<SalaryAllocation />} />
          <Route path="/payroll-allocation-add" element={<SalaryAllocationAdd />} />
          <Route path="/payroll-allocation-edit/:id" element={<SalaryAllocationEdit />} />
          <Route path="/payroll-allocation-view/:id" element={<SalaryAllocationView />} />
          <Route path="/payslip" element={<Payslip />} />
          <Route path="/payslip-view/:id" element={<PayslipView />} />
          <Route path="/payslip-approval" element={<PayslipApproval />} />
          <Route path="/payslip-edit/:id" element={<PayslipEdit />} />
          <Route path="/attendance" element={<AttendanceUpdate />} />
          <Route path="/salary-structure" element={<SalaryStructure />} />
          <Route path="/store-assets" element={<StoreAssets />} />
          <Route path="/store-assets-add" element={<StoreAssetsAdd />} />
          <Route path="/store-assets-edit/:id" element={<StoreAssetsEdit />} />
          <Route path="/asset-view/:id" element={<StoreAssetsView />} />
          <Route path="/apply-resignation" element={<ApplyResignation />} />
          <Route path="/application-status" element={<ApplicationStatus />} />
          <Route path="/application-status-view/:id" element={<ApplicationStatusView />} />
          <Route path="/assets-handover" element={<AssetsHandover />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Route>
      </Routes>
    </BrowserRouter>

  );
}

export default App;
